import { render, staticRenderFns } from "./Tabs.html?vue&type=template&id=795015ae&scoped=true&"
import script from "./Tabs.js?vue&type=script&lang=js&"
export * from "./Tabs.js?vue&type=script&lang=js&"
import style0 from "./Tabs.scss?vue&type=style&index=0&id=795015ae&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "795015ae",
  null
  
)

export default component.exports